import { theme } from "@huub-web/ui/theme/css/theme.css";
import { style } from "@vanilla-extract/css";
import { responsive } from "@huub-web/ui/utils/responsive";

const NAV_BUTTONS_BREAKPOINT = 800;

export const sectionStyle = style({
  overflow: "visible",
  gap: theme.spacings.m,
});

export const navWrapperStyle = style({
  position: "sticky",
  top: 126,
  zIndex: 10,
  backgroundColor: theme.colors.backgroundTint,
});

export const firstLetterCapitalStyle = style({
  selectors: {
    "&:first-letter": {
      textTransform: "uppercase",
    },
  },
});

export const navContainerStyle = style({
  gap: theme.spacings.s,
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  pointerEvents: "none",
  paddingBottom: theme.spacings.s,
  paddingTop: theme.spacings.s,
});

export const leadingButtonStyle = style({
  display: "none",
  ...responsive({
    [NAV_BUTTONS_BREAKPOINT]: {
      display: "flex",
    },
  }),
});

export const headingStyle = style({
  flexGrow: 1,
});

export const containerStyle = style({
  width: "100%",
});

export const trailingButtonsStyle = style({
  display: "flex",
  ...responsive({
    [NAV_BUTTONS_BREAKPOINT]: {
      display: "none",
    },
  }),
});
